export default __webpack_public_path__ + "static/help_02_04_1-ad752a4636fdec1316b92389e4782617.png";